module.exports = __webpack_public_path__ + "img/ico_circle_arrow.svg";